import script from "./ResidentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ResidentTable.vue?vue&type=script&setup=true&lang=js"

import "./ResidentTable.vue?vue&type=style&index=0&id=5c09b719&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c09b719"]])

export default __exports__